export default "__VITE_ASSET__BS1QXhEb__"